import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale';
import {fetchTeacher} from 'containers/pages/Teacher/ducks'
import { connect } from 'react-redux';
import registerTeacher from 'controllers/teacher/registerTeacher'
import updateTeacher from 'controllers/teacher/updateTeacher'

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchTeacher: (schoolId, state) => dispatch(fetchTeacher(schoolId, state)),
	};
};


class ModalBody extends React.Component {

  constructor(props){
    super(props)

		this.state = {
			disabledBtn: false
		}
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
      mode,
    } = this.props;

    const schoolId = localStorage.getItem('schoolId')
		return (
      <Modal
        className='create-teacher-modal'
        isShowingModal={show}

        onCloseModalClick={dismiss}
        fixedWidth={600}
        overlayColor="#000"

        hasHeader={true}
        headerTitle={ this.props.mode == 'create' ? __('Create Teacher', locale) : __('Edit Teacher', locale)}
        headerType="bold"
        footerType="grey"
        hasFooter={true}
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: `btn btn-primary pull-right`,
            onClick: ()=>{
              const validateResult = this.validate();
              if (!validateResult.ok) {
                return;
              }
              this.setState({disabledBtn: true})

              if(typeof this.formData === 'undefined'){
                return this.props.dismiss()
              }

              if (this.formData.profile_photo && this.formData.profile_photo.file) {
                this.formData.photo = this.formData.profile_photo.file;
                delete this.formData.profile_photo;
              }
              
              if(mode == 'create'){
                this.formData.tPhone = this.formData.phoneParsed.country_code.toString() + this.formData.phoneParsed.national_number.toString()
                if(this.formData.tPhone.length < 2){
                  delete this.formData.tPhone
                }
                delete this.formData.phoneParsed;

								registerTeacher(schoolId, this.formData)
								.then((res) => {
									if(res.id){
										this.props.fetchTeacher({schoolId, amount_per_page: 25, current_page_number: 1}, 'current')
										this.props.proceed()
									} else if(res.result == 'failure' && res.reason == 'another teacher with the same phone number exists.'){
										alert.warning(__('Phone number already existed', locale))
										this.setState({disabledBtn: false})
									} else if (res.result == 'failure' && res.reason == 'teacher with the same phone has been archived'){
                    alert.warning(__('Phone number already existed in Archived Teacher', locale))
										this.setState({disabledBtn: false})
                  }
								})
              } else if (mode == 'update'){
                if(this.formData.phoneParsed.national_number !== ''){
                  this.formData.stPhone = this.formData.phoneParsed.country_code.toString() + this.formData.phoneParsed.national_number.toString();
                }else {
                  this.formData.stPhone = ''
                }
								if(this.formData){
                  const {id, tName, tGender, tEmail, photo, stPhone} = this.formData
                  let newFormData = {stName: tName, stGender: tGender, stEmail: tEmail, photo: photo, stPhone}
									updateTeacher(this.props.teacherId, newFormData)
									.then((res) => {
										if(res.id){
											this.props.fetchTeacher({schoolId, amount_per_page: 25, current_page_number: 1}, 'current')
											this.props.proceed()
										} else if (res.result == 'failure' && res.reason == 'another teacher with the same phone number exists.'){
											alert.warning(__('Phone number already existed', locale))
											this.setState({disabledBtn: false})
										} else if (res.result == 'failure' && res.reason == 'teacher with the same phone has been archived'){
                      alert.warning(__('Phone number already existed in Archived Teacher', locale))
											this.setState({disabledBtn: false})
                    }
									})
								} else {
									this.props.proceed()
								}
              }
            },
						isDisabled: ()=>{
							return this.state.disabledBtn
						}
          },
        ]}
      >
        <ModalContent
          {...this.props}
          onFormChange={(stateFromModalContent)=>{ this.formData = stateFromModalContent; }}
          getValidationRef={(fn)=>{
            this.validate = fn;
          }}
        />
      </Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(confirmable(ModalBody));



// WEBPACK FOOTER //
// ./src/template/Modals/CreateTeacher/ModalBody.js